/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InvolvementQuestion {
  id: number
  category: InvolvementQuestionCategoryEnum
  text: string
  description?: string
  questionVersion: number
  questionType: InvolvementQuestionQuestionTypeEnum
}

export const InvolvementQuestionCategoryEnum = {
  EMPLOYMENT: "EMPLOYMENT",
  TERRITORY: "TERRITORY",
  SOCIAL: "SOCIAL",
  ENVIRONMENT: "ENVIRONMENT",
  GOVERNANCE: "GOVERNANCE",
  OTHER: "OTHER"
} as const

export type InvolvementQuestionCategoryEnum =
  (typeof InvolvementQuestionCategoryEnum)[keyof typeof InvolvementQuestionCategoryEnum]
export const InvolvementQuestionQuestionTypeEnum = {
  QUESTION: "QUESTION",
  EXCLUDE_CRITERIA: "EXCLUDE_CRITERIA",
  PREVENTION: "PREVENTION"
} as const

export type InvolvementQuestionQuestionTypeEnum =
  (typeof InvolvementQuestionQuestionTypeEnum)[keyof typeof InvolvementQuestionQuestionTypeEnum]
